import { getDb } from '@/services/db/database';

const CACHE_KEY = 'auth.encryptionKey';

interface CachedKeyRecord {
  uid: string;
  key: CryptoKey;
  salt: string;
  storedAt: string;
}

export interface CachedKey {
  key: CryptoKey;
  salt: string;
}

export async function saveCachedKey(uid: string, key: CryptoKey, salt: string): Promise<void> {
  const record: CachedKeyRecord = {
    uid,
    key,
    salt,
    storedAt: new Date().toISOString(),
  };
  await getDb().settings.put({ key: CACHE_KEY, value: record });
}

export async function loadCachedKey(uid: string): Promise<CachedKey | null> {
  const row = await getDb().settings.get(CACHE_KEY);
  if (!row) return null;
  const record = row.value as CachedKeyRecord | undefined;
  if (!record || record.uid !== uid) return null;
  if (!(record.key instanceof CryptoKey)) return null;
  return { key: record.key, salt: record.salt };
}

export async function clearCachedKey(): Promise<void> {
  await getDb().settings.delete(CACHE_KEY);
}
